export default __webpack_public_path__ + "static/media/doctor_1.401ef822.jpg";